// ウィジェットのCSSを1回だけ注入する。
//
// 同じページに同種のウィジェットが複数載っても <style> は1つで足りる。
// 店側のフリーページに CSS を書かせないための仕組みなので、注入はJSの責任で行う。

const injected = new Set<string>()

export function injectStyleOnce(key: string, css: string): void {
  if (injected.has(key)) return
  injected.add(key)

  const el = document.createElement('style')
  el.setAttribute('data-wu-style', key)
  el.textContent = css
  document.head.appendChild(el)
}
